<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [{"num_cand":"U2FsdGVkX18MuFHzVIoUTZeZf9cinkGVn42ZATnL954=","cpf":"U2FsdGVkX183OeqJ6rtJ+1VgeEszpQbxZUOl+vRGk2Y="},{"num_cand":"U2FsdGVkX185MhBo/rQgf5bDKIvoBv3BhGEzKUFz97g=","cpf":"U2FsdGVkX18i0pqwpoi/VxCR1c7x/CtqQERVoXlpvp0="},{"num_cand":"U2FsdGVkX1+5GIKUEpB3ekydY+MCtpTRmy07xZzI6mU=","cpf":"U2FsdGVkX1+re01S2bEyQNDKU0DobPeLiLoZEx94bNc="},{"num_cand":"U2FsdGVkX1/MZQCniKBlKMJwtGJraNBbPdvW4aZlUto=","cpf":"U2FsdGVkX19eKaF1FNgWGId/sIZS/qPfq0LXVrgQM5I="},{"num_cand":"U2FsdGVkX18sQoVzP0oQYFVIsI0S1rzRfKfNNnLqL5w=","cpf":"U2FsdGVkX1/prWoZqhof6zgFtxkNTBc1fa7rGj6Z9CQ="},{"num_cand":"U2FsdGVkX1+HbzVh72wbeO/U7DIo4nPODkVOgqZv3eU=","cpf":"U2FsdGVkX1/V7P/Ek7D04ELFaGvrMgOSgCMLXEB+zhY="},{"num_cand":"U2FsdGVkX1/kwxsRrBp3kZi83LAmsh3kypRy5hIpzck=","cpf":"U2FsdGVkX1/TR1UbWfU9c21dNNRCw+10luPjWVh+MZE="},{"num_cand":"U2FsdGVkX1/w1jpPd+COY8kwXmGoU497EbRqjvd6ySA=","cpf":"U2FsdGVkX18vWQ8zppdz9vRQsxeQGNxpzO892SJePbI="},{"num_cand":"U2FsdGVkX1/PUnKFNVwQFoYW0+lxu6UpLSO+XBadtto=","cpf":"U2FsdGVkX18wgmR+9AZ6d/ZFbSW+7FDOQRx9/QiA7Ks="},{"num_cand":"U2FsdGVkX18wldmgwh1idfDIroBl7dSEWHWE6kNThFE=","cpf":"U2FsdGVkX1/T45JnAlI/QMJrzk0KGEsGaHIyYdZreNA="},{"num_cand":"U2FsdGVkX1+KuiNEN9T36kwN7uYOv0Ogcsfbyo2J0Qo=","cpf":"U2FsdGVkX1856K2H83KVjWzq9h2qywKdWRTaLqUGrxA="},{"num_cand":"U2FsdGVkX1+PTnPE63gc3+NMMEO4vnj0XaHkkEcAvpM=","cpf":"U2FsdGVkX188QhcF/KV+mp6HJN06hx+uV+x/+sEq0bE="},{"num_cand":"U2FsdGVkX1/0rTw4m2JXiXqmAi7A2R+SPnHRhRHF6bA=","cpf":"U2FsdGVkX1/eMb7gtCf3LU6XgxX2kSjZo8gdw+Pg+TU="},{"num_cand":"U2FsdGVkX1+WzCzrJmBJuCZ+42VU5eOZrxIJ25VFtVs=","cpf":"U2FsdGVkX180ubziOjCxd3a+ywQrYxEBMRuvCBzpchU="},{"num_cand":"U2FsdGVkX18bPsPmtvPStokmWs3EFaYXkwsSew8rHZQ=","cpf":"U2FsdGVkX18smI8vDThbXr8FOUN1685m1JyZXMMCplU="},{"num_cand":"U2FsdGVkX1+gZhsaUfsi7Q4QSsqQu/Y9bGVToGpiWqc=","cpf":"U2FsdGVkX1++vfBZnSjegdOAH8pQ+4KTj/DxLhjlFMM="},{"num_cand":"U2FsdGVkX18B2ZAvjuAECyd3Nz6/F/JK0S4OpTfGsLY=","cpf":"U2FsdGVkX1+OvLdsyPPoN4VrUrBMCEVNteSLk9VyVn8="},{"num_cand":"U2FsdGVkX1+oGmQkVNuOnH/fijnpmDvU1pXLB+1vivU=","cpf":"U2FsdGVkX1+8P5VESuS200CzC+ntqH+OECbsWFxRkA8="},{"num_cand":"U2FsdGVkX18Y2TOqN3ghHdhz9hTLDTs8NA4aohnlAwY=","cpf":"U2FsdGVkX1/LHwb2NhUGC9CiN4oX3R7NlXDiXBR9JvY="},{"num_cand":"U2FsdGVkX1+Pd2gZwfwVpHZI6it5mdkd72DOFvdEzCk=","cpf":"U2FsdGVkX1+5vVi13fUGx5RF1ZrW+BQD464u3jZmipI="},{"num_cand":"U2FsdGVkX19huuYsIgb26ltowQzmcG8E12j1RvcZLXw=","cpf":"U2FsdGVkX18UnWdR+uCl0nILtHA2j84isa3gDQfFIkk="},{"num_cand":"U2FsdGVkX1/Ba/WmIp6zbP8+LgZJvPJtUPqefIlqW7M=","cpf":"U2FsdGVkX1+MdSHo/xnak92MHVq568Gsj4FlnwjeWvc="},{"num_cand":"U2FsdGVkX1+L0KdGAh3vzHQ4OoyUKVU8dU6rEute4FA=","cpf":"U2FsdGVkX1+5vOBUea4Pe6n+FaK+gBtVCt3gXjYIqgY="},{"num_cand":"U2FsdGVkX18amdPJiHxu0xUo7edDKCb5Ya6ImVZSDQk=","cpf":"U2FsdGVkX18M556+dDEH6geC7mbS9R/ouhfL57SPPhk="},{"num_cand":"U2FsdGVkX1/CFWE0GdyelgeGIOHG/ti7jBjXfB94wDI=","cpf":"U2FsdGVkX1+ySLdWx3Dqh7APXNnNUf/tNHPNzfuwMbY="},{"num_cand":"U2FsdGVkX1/yVrN2nQI6YYKfsnYBql18ifxIKLqNrAE=","cpf":"U2FsdGVkX198vEoP2P1y1qWpPFoMHzfHzRe/OmsV84o="},{"num_cand":"U2FsdGVkX19MibkPxX77yzgTMBOLurLS8V+Cf+gYySY=","cpf":"U2FsdGVkX18NgOT/onzQb89YxFJ9/txii/6MrVk5dVA="},{"num_cand":"U2FsdGVkX1/730MDSoC4HFTUipSilBewQrdTrugh+m8=","cpf":"U2FsdGVkX1+dc0EI62U3+abhQsJnosuaDxO5MNgQwyY="},{"num_cand":"U2FsdGVkX1+AmJAKhw9QzgDgX5bSMjuxOZ4WMn+c8P8=","cpf":"U2FsdGVkX18ZS3yobOxbO/nwdQpdacACOvyuYVEb7wo="},{"num_cand":"U2FsdGVkX19nkIwSdx0C8jwXiNgmAR3fcC4rG8x7AKg=","cpf":"U2FsdGVkX1+4N2X5TL2AP0YWsuRc+2xDrBQCGpBCvxY="},{"num_cand":"U2FsdGVkX18bd1tfZ9h3MzsiS04syJn+SIO37fjDlXQ=","cpf":"U2FsdGVkX18BNLa34NgHw8ft9NYugYK7dRIaElsG7zg="},{"num_cand":"U2FsdGVkX18Jb65fPAtpz8aSlA0ca4XDGIZXldPlwls=","cpf":"U2FsdGVkX1+9HEDtrkh+iiqmLjyw7AzqTNf4oBTpeCQ="},{"num_cand":"U2FsdGVkX19QyD4XKAFW8jhhdt3e8dJGtpxSsr5PxJQ=","cpf":"U2FsdGVkX1/VbtbjUpllBzy2sfwtxUKYwY9r35f/Up8="},{"num_cand":"U2FsdGVkX1/roDFzC2qyW5j2L1/t/hlyLvmBPAk/YbQ=","cpf":"U2FsdGVkX18WKXOqJIpPFjvRKy+pDxDGNZBQwvnbfb4="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2206/disc_rec_po/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
